import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../../Assets/Images/home_bottom.png';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Container, Grid } from '@mui/material';
import "./style.css"
import { useNavigate } from 'react-router';

const drawerWidth = 240;
const navItems = ['SIGN UP', 'LOG IN'];

export const Dashboard = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate()

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleClick = (e) => {
    e === 'SIGN UP' ? navigate('/register') : navigate('/login')
  }

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ mr: 2, display: { sm: 'none' } }}
      >
        <img src={Logo} alt='Logo' />
      </IconButton>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }} onClick={() => handleClick(item)}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box className="main">

      <CssBaseline />
      <Container maxWidth="lg">
      <Grid container spacing={2}>
        <AppBar component="nav" className='navbar'>
          <Toolbar className='nav-toolbar'>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' }}}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            >
              <img src={Logo} alt='Logo' />
            </Typography>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              {navItems.map((item) => (
                <Button key={item} onClick={() =>handleClick(item)} sx={{ color: '#fff' }}>
                  {item}
                </Button>
              ))}
            </Box>
          </Toolbar>
        </AppBar>
         </Grid>
      </Container>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>

      <Box component="main" className='content-box'>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item xs={7}>
              {/* <Toolbar /> */}
              <Box className="content-details">
                <Typography className='page-title' variant="h5">
                  INTEGRATIVE ONCIOLOGY <br />
                  IN ACTION
                </Typography>
                <Typography component="p">
                  Oncio is a mobile app designed to assist cancer patients in managing their care.
                  It offers guided programs, health tracking, and curated content to support patients throughout the treatment process and beyond.
                  It includes features such as symptom tracking, appointment scheduling, and educational resources to help patients stay informed and in control of their health.
                  The app aims to empower patients to take an active role in their care and improve their quality of life during recovery.
                </Typography>
                <Box>
                  <Button variant='contained' className='join-now-btn' size="small" onClick={() => navigate('/register')}>Join Now</Button>
                </Box>
              </Box>
            </Grid>


          </Grid>
        </Container>
      </Box>
    </Box>
  );
}

Dashboard.propTypes = { 
  window: PropTypes.func,
};
